import React from 'react';
import Hero from './components/administration/officer-incharge/Hero';
import Main from './components/administration/officer-incharge/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const OfficerIncharge = () => {
  return (
    <div>
        <Hero />
        <Main />
        <ImportantLinksSlider />
    </div>
  )
}

export default OfficerIncharge;